<script lang="ts">
  import ActionBarCard from "@shared/svelte/Components/ActionBarCard.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import {
    ActionBarCardEntity,
    ActionBarCardTypes,
  } from "@shared/services/event_tracking/entities";

  const { trackClick, trackMrcEvents } = EventTracking;

  const trackingParams = [
    new ActionBarCardEntity({
      card_type: ActionBarCardTypes.ApprovedProducts,
    }),
  ];

  const src: string = window["C"].IMAGE_PATHS["approved_products.png"];
</script>

<a
  href="/lists"
  class="fizz-underline-none"
  data-testid="action_bar_approved_products"
  on:click={() => trackClick("action_bar_approved_products", trackingParams)}
  use:trackMrcEvents={[trackingParams]}
>
  <ActionBarCard
    titleText="Approved Products"
    icon="Lists"
    iconFill="black"
    cardHeaderPadding="fizz-stack-16"
  >
    <div slot="body" class="fizz-flex-row fizz-text-strong fizz-inset-horizontal-8">
      <img {src} alt="approved_products_image" style="min-height: 93px; width:100px" />

      <div class=" fizz-text-left">
        <p class="fizz-text-brand fizz-underline-none">Shop products for your organization</p>
        <p class="fizz-text-small fizz-text-link"> See all approved products</p>
      </div>
    </div>
  </ActionBarCard>
</a>
